export default "__VITE_ASSET__DWexayI1__"